export default __webpack_public_path__ + "static/media/facebook-icon.86357bac.svg";